import React, { Component } from 'react'
import CSSModules from 'helpers/CSSModulesUtil'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { Flex, Box } from 'reflexbox'
import T from 'i18n-react'
import { CSVLink } from 'react-csv'

import { onEnter } from 'helpers/events'

import Input from './Input'
import ProgressBar from './ProgressBar'
import Dropdown from './Dropdown'
import Chip from './Chip'
import Card from './Card'
import IconButton from './IconButton'
import Button from './Button'
import Record from './Record'
import Table from 'containers/Project/ElasticSearch/Table'

import Dialog from '../Dialog'


import {
  onInputChange,
  onSubmit,
  onFieldButtonClick,
  onRowSizeChange,
  onClearAll,
  onHeaderFilterRemove,
} from '../actions'

import {
  inputValueSelector,
  rowSizeSelector,
  rowSizeStateSelector,
  listSelector,
  totalStateSelector,
  chipFiltersSelector
} from '../selectors'

const mapStateToProps = (state) => {
  return {
    list: listSelector(state),
    inputValue: inputValueSelector(state),
    rowSizes: rowSizeSelector(state),
    rowSize: rowSizeStateSelector(state),
    total: totalStateSelector(state),
    chips: chipFiltersSelector(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onEnterPress: onEnter((event) => dispatch(onSubmit(event))),
    onInputChange: (value) => dispatch(onInputChange(value)),
    onButtonClick: () => dispatch(onFieldButtonClick()),
    onRowSizeChange: (rowSize) => dispatch(onRowSizeChange(rowSize)),
    onClearFilters: () => dispatch(onClearAll()),
    onDeleteClick: (type, value) => dispatch(onHeaderFilterRemove(type, value)),
  }
}

class SearchCard extends Component {
  onDeleteClick = (type, value) => () => this.props.onDeleteClick(type, value)

  render() {
    const {
      list,
      inputValue,
      onInputChange,
      onEnterPress,
      onButtonClick,
      onRowSizeChange,
      onClearFilters,
      onDeleteClick,
      rowSizes,
      rowSize,
      total,
      chips
    } = this.props
    let temp = chips.filter((chip) => {
      return (!['product_segment', 'product_line', 'product_family', 'product_platform', 'product_sku', 'product_brand'].includes(chip[0]))
    })
    return (
      <Card>
        <Flex align='center' mr={1}>
          <Box auto>
            <Input
              icon='search'
              hint= 'Search Project...'
              value={inputValue}
              onChange={onInputChange}
              onKeyPress={onEnterPress}
            />
          </Box>
          <Dropdown
            value={rowSize}
            source={rowSizes}
            onChange={onRowSizeChange}
            label='Row Size'
          />
          {/* <IconButton
            icon='refresh'
            onClick={onClearFilters}
            message={T.translate('pages.project.search.notification.reset_filters')}
          /> */}
          <CSVLink
            data={list}
            filename='fulcrum_data.csv'
            target='_blank'
          >
            <IconButton
              icon='open_in_new'
              message={T.translate('pages.project.search.notification.csv_button')}
            />
          </CSVLink>
        </Flex>
        <Flex style={{flex: '0 0 38px'}} mx={2} justify='space-between'>
          <Box auto>
            {
              temp.map(([type, value]) => (
                <Chip
                  key={`filter_type_${type}_${value}`}
                  deletable
                  onDeleteClick={this.onDeleteClick(type, value)}
                  content={value}
                />
              ))
            }
          </Box>
          <Box>
            <Record>
              {T.translate('containers.project.search.index.totalSize', { total, size: list.length - 1 })}
            </Record>
          </Box>
        </Flex>
        <Table/>
        <ProgressBar/>
      </Card>
    )
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const enhance = compose(
  withConnect,
)

export default enhance(SearchCard)
